import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  authorizedRequest
} from "utils/api";
import {
  API_META
} from "constants/apiRoutes";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const META_FETCH_REQUEST = "META_FETCH_REQUEST";
export const META_FETCH_SUCCESS = "META_FETCH_SUCCESS";
export const META_FETCH_FAILURE = "META_FETCH_FAILURE";

const initialState = {};

export default function metaReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case META_FETCH_SUCCESS:
      return {
        ...state,
        ...payload
      };

    default:
      return state;
  }
}

/**
 * Get all meta
 * @return {Object} Action
 */
export function fetchMeta() {
  return {
    type: META_FETCH_REQUEST
  };
}

export function metaFetchSuccess(payload) {
  return {
    type: META_FETCH_SUCCESS,
    payload
  };
}

function metaFetchFailure(payload) {
  return {
    type: META_FETCH_FAILURE,
    payload
  };
}

// Saga
function* fetchSaga() {
  try {
    const response = yield call(authorizedRequest, API_META);
    yield put(metaFetchSuccess(response));
  } catch (error) {
    yield put(metaFetchFailure(error));
    ToastError(error.message);
  }
}

export function* metaSaga() {
  yield takeLatest(META_FETCH_REQUEST, fetchSaga);
  yield fetchSaga();
}
